export default function SectionTitle({ eyebrow, title, text }) {
  return (
    <div className="mb-8 max-w-3xl">
      {eyebrow && <p className="mb-2 text-sm font-black uppercase tracking-[0.18em] text-orange">{eyebrow}</p>}
      <h1 className="text-3xl font-black leading-tight text-ink md:text-5xl">{title}</h1>
      {text && <p className="mt-4 text-base leading-7 text-muted md:text-lg">{text}</p>}
    </div>
  );
}
